import React from 'react';
import {CommonCreate} from '../Common';
import {getInputs} from './Common';
import {useNotify} from 'react-admin';

export const DocumentTypeCreate = props => {
  const notify = useNotify();

  const handleFailure = error => {
    // Afficher le message d'erreur dans la notification
    notify(
      typeof error === 'string' ? error : error.message || 'Une erreur est survenue',
      {type: 'warning'}
    );
  };

  return (
    <CommonCreate
      {...{
        ...props,
        onFailure: handleFailure,
        fields: [...getInputs()],
      }}
    />
  );
};
